export const chainOptions = [
  {
    value: "all",
    label: "All chains",
  },
  {
    value: "Ethereum",
    label: "Ethereum",
  },
  {
    value: "Avalanche",
    label: "Avalanche",
  },
  {
    value: "Fantom",
    label: "Fantom",
  },
  {
    value: "Optimism",
    label: "Optimism",
  },
  {
    value: "Polygon",
    label: "Polygon",
  },
  {
    value: "Solana",
    label: "Solana",
  },
  {
    value: "BNB Chain",
    label: "BNB Chain",
  },
  {
    value: "Arbitrum",
    label: "Arbitrum",
  },
  {
    value: "DeFiChain",
    label: "DeFiChain",
  },
  {
    value: "Cronos",
    label: "Cronos",
  },
  {
    value: "Waves",
    label: "Waves",
  },
  {
    value: "Tron",
    label: "Tron",
  },
  // {
  //   value: "Moonriver",
  //   label: "Moonriver",
  // },
  // {
  //   value: "Moonbeam",
  //   label: "Moonbeam",
  // },
];
